export default class CalculatorGF {


    constructor() {
        this.addEvents();
    }

    addEvents(){
        const that = this;
        jQuery('.calculator-form').on('input', () => {
            let index = jQuery('.calc__tab.active').index() + 1;
            this.calculator(index);
        });

        jQuery('.calc__tabs').on('click', '.calc__tab', function(e){
            let index = jQuery(this).index() + 1;
            jQuery('.calc__tab').removeClass('active');
            jQuery(this).addClass('active');
            that.calculator(index);
        });

        jQuery('.calc-month').on('click', 'span', function(e){
            jQuery( this ).toggleClass( "active" );
        })

        jQuery('.calc-month__list').on('click', 'div', function(e){
            let span = jQuery( this ).parents('.calc-month').find('span');
            span.removeClass('active');
            jQuery(this).siblings().removeClass('active');
            jQuery(this).toggleClass('active');
            span.html(jQuery( this ).html());
            jQuery('.financing-input input').val(jQuery( this ).html()).trigger('input');
        })

        jQuery(document).on('gform_post_render', function(){
            jQuery(".annual-input input, .monthly-input input, .vpos-price-input input, .onyx-price-input input, .total-amount-input input").attr("readonly","readonly");

            const numberSelectors = ['.calculator-form-secondary .vpos-units-input input[type="number"]', '.calculator-form-secondary .onyx-units-input input[type="number"]'];
            numberSelectors.forEach(selector => {
                const inputField = jQuery(selector);
                if (inputField.length) {
                    // Create increment and decrement buttons
                    const decrementButton = jQuery('<button type="button">-</button>');
                    const incrementButton = jQuery('<button type="button">+</button>');

                    // Insert buttons before and after the input field
                    inputField.before(decrementButton);
                    inputField.after(incrementButton);

                    // Add event listeners for the buttons
                    incrementButton.on('click', () => {
                        const currentValue = parseInt(inputField.val()) || 0;
                        inputField.val(currentValue + 1).trigger('input');
                    });

                    decrementButton.on('click', () => {
                        const currentValue = parseInt(inputField.val()) || 0;
                        if (currentValue > 0) {
                            inputField.val(currentValue - 1).trigger('input');
                        }
                    });
                }
            });

        });
    }


    calculator(type) {
        if(type == 2) {
            jQuery('.vpos-units-input, .vpos-price-input').css('display', 'none');
            jQuery('.onyx-price-input, .onyx-units-input').css('display', 'flex');
        } else {
            jQuery('.vpos-units-input, .vpos-price-input').css('display', 'flex');
            jQuery('.onyx-price-input, .onyx-units-input').css('display', 'none');
        }

        const annual = parseFloat(jQuery('.annual-input  input').val());
        const monthly = jQuery('.monthly-input  input');
        const financing = parseFloat(jQuery('.financing-input input').val());
        const vpos_price = parseFloat(jQuery('.vpos-price-input input').val());
        const vpos_units = parseFloat(jQuery('.vpos-units-input input').val());
        const onyx_price = parseFloat(jQuery('.onyx-price-input input').val());
        const onyx_units = parseFloat(jQuery('.onyx-units-input input').val());
        const total_amount = jQuery('.total-amount-input input');
        const monthly_percent = ((Math.pow(1 + (annual / 100), 1 / 12) - 1) * 100);
        const daily_payment = jQuery('.daily_payment div');
        const monthly_payment = jQuery('.monthly_payment div');
        const total_amount_full = type == 2 ? onyx_units * onyx_price : vpos_units * vpos_price;
        const plt = !isNaN(total_amount_full) ? (total_amount_full * (monthly_percent / 100)) / (1 - Math.pow((1 + monthly_percent / 100), -financing)) : 0;

        // Display the calculated values
        monthly_payment.html('$' + plt.toFixed(0));
        daily_payment.html('$' + (plt / 30).toFixed(0));
        total_amount.val(!isNaN(Number(total_amount_full)) ? '$' + Number(total_amount_full).toLocaleString('en-US') : '$0');
        monthly.val(!isNaN(monthly_percent) ? monthly_percent.toFixed(2) : 0);

        // Show total amount full in the element with the class 'total_amount_full_el'
        jQuery('.total_amount_full_el').html('$' + (!isNaN(Number(total_amount_full)) ? Number(total_amount_full).toLocaleString('en-US') : '0'));

    }

}
